import * as React from 'react';

import { cn } from '../../lib/utils';

export interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {}

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(({ className, ...props }, ref) => {
  return (
    <textarea
      className={cn(
        'flex h-10 min-h-[80px] w-full rounded-input border border-input-default-static-border bg-input-default-static-background px-3 py-2 text-sm',
        'placeholder:text-input-default-static-placeholder',
        'focus-visible:border-2 focus-visible:border-input-default-focus-border focus-visible:bg-input-default-focus-background',
        'disabled:cursor-not-allowed disabled:opacity-50',
        className,
      )}
      ref={ref}
      {...props}
    />
  );
});
Textarea.displayName = 'Textarea';

export { Textarea };
